export default "__VITE_ASSET__018cf85e__"